<template>
  <Toolbar class="p-0 mb-2">
    <template #start>
      <EquipmentRouteDropdown />
    </template>
    <template v-if="title !== 'Housings'" #end>
      <Button
        label="Duplicate"
        :disabled="!isOnline || disableDuplicate"
        class="ml-2"
        @click="handleDuplicateRow"
      />

      <Button
        v-if="enableRestore"
        data-cy="restore-button"
        label="Restore"
        :disabled="!isOnline || disableRestoreDelete"
        class="ml-2"
        @click="handleRestore"
      />

      <Button
        v-if="!enableRestore"
        data-cy="delete-button"
        label="Delete"
        :disabled="!isOnline || disableRestoreDelete"
        class="ml-2"
        @click="handleDelete"
      />

      <Button
        data-cy="add-button"
        label="Add"
        class="ml-2"
        :disabled="!isOnline || !enableAdd"
        @click="handleRowCreate"
      />
    </template>
  </Toolbar>
</template>
<script setup lang="ts">
import { injectStrict } from "@/utils/utils";
import { useOnline } from "@vueuse/core";
import EquipmentRouteDropdown from "@/components/EquipmentRouteDropdown.vue";
import type {
  BaseEquipment,
  UseEquipment
} from "@/composables/equipment/equipmentTypes";

const equipment = injectStrict<UseEquipment<BaseEquipment>>("equipment");
const {
  enableAdd,
  enableRestore,
  disableRestoreDelete,
  disableDuplicate,
  handleDuplicateRow,
  handleRestore,
  handleRowCreate,
  handleDelete,
  title
} = equipment;
const isOnline = useOnline();
</script>
